export default function GoogleLoginButton(props) {
  let { redirectTo = "" } = props;
  if (!redirectTo) {
    const { pathname } = window.location;
    if (pathname.includes('log-in') || pathname.includes('sign-up')) redirectTo = "/";
    else redirectTo = pathname;
  }

  const href = `${process.env.REACT_APP_BACK_END_DOMAIN}/api/session/login/google?redirectTo=${redirectTo}`;

  return (
    <a
      className='btn btn-danger google-icon'
      href={href}
      style={{ margin: 5, padding: 2, width: 220 }}
    >
      <i className="fab fa-google" />
      {" "}
      Sign In with Google
    </a>
  );
}